import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'react-select';
import { Button, Label, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';

import { PUBLISH_APPROVAL, PUBLISH_APPROVAL_EMPTY } from '../../../../../../../../store/actions';

const PublishApproval = ({ onClose, currentSelectedBooking, cardName, approvalType }) => {
  const dispatch = useDispatch();

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { publishConfiguration, publishConfigurationLoading } = useSelector(state => ({
    publishConfiguration: state?.PublishApproval?.data,
    publishConfigurationLoading: state?.PublishApproval?.loading,
  }));

  const handleSubmit = () => {
    dispatch({
      type: PUBLISH_APPROVAL,
      payload: {
        data: {
          id: currentSelectedBooking?.id,
          cardName: cardName,
        },
      },
    });
  };

  useEffect(() => {
    if (publishConfiguration !== null) {
      dispatch({
        type: PUBLISH_APPROVAL_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: PUBLISH_APPROVAL_EMPTY,
      });
    };
  }, [publishConfiguration]);

  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose}></ModalHeader>

      <ModalBody>
        <p className="fs-22 text-center">Are you sure you want to publish this {approvalType}</p>
      </ModalBody>

      <div className="d-flex justify-content-center mb-4 gap-3">
        {!publishConfigurationLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        )}

        {publishConfigurationLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}

        <Button color="white" style={{ fontSize: '14px', width: '100px', borderRadius: '10px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default PublishApproval;
